'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { t } from '../../i18next';
import { useEffect, useState } from 'react';
import HeaderScreenList from '../../features/attributes_access/components/HeaderScreenList';
import { useConfigContext } from '../../shared/context/ConfigContext';
import { getChildTableDetailsService } from '../../features/getChildTableDetailsService';
import ScreenAccessColumnConfig from '../../features/screens_access/components/ScreenAccessColumnConfig';
import { CommitHandler } from '../../features/features_access/CommitHandler';
import GridTable from '../../shared/components/grid/GridTable';
import { useScreensDropdownOptions } from '../../features/admin';

const FeatureAccessPage = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('features_access');
  const [selectedGrid, setSelectedGrid] = useState(null);

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <FeatureAccess
                    tableRes={item}
                    selectedGrid={selectedGrid}
                    setSelectedGrid={setSelectedGrid}
                  />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default FeatureAccessPage;

const FeatureAccess = ({ tableRes, selectedGrid, setSelectedGrid }) => {
  const screenGridId = tableRes.id;
  const { updateCustomConfig } = useColumnContextAPI();
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [gridOptions, setGridOptions] = useState([]);
  const { configSchema } = useConfigContext();
  const { screenOptions } = useScreensDropdownOptions(screenGridId);

  useEffect(() => {
    setSelectedScreen(screenOptions[0]?.value);
  }, [screenOptions]);

  useEffect(() => {
    if (selectedScreen) {
      getChildTableDetailsService(tableRes.id, selectedScreen, configSchema).then((res) => {
        const options = res[`${configSchema}_mbd_screen_to_data_grids`]?.map((item) => ({
          value: item.id,
          label: item.mbdDatagrid.dataGridInternalName,
        }));
        setGridOptions(options);
        setSelectedGrid(options[0].value);
      });
    }
  }, [selectedScreen]);

  useEffect(() => {
    updateCustomConfig({
      ScreenSlotProps: {
        screen: 'featureAccess',
        updateValue: setSelectedScreen,
        initialValue: selectedScreen,
        updateGridValue: setSelectedGrid,
        initialGridValue: selectedGrid,
        screenOptions,
        gridOptions,
      },
      AdditionalHeaderComp: [{ name: 'headerScreenList', Component: HeaderScreenList }],
      SetColumnConfig: ScreenAccessColumnConfig,
      SetIsCellEditable,
      uniqueValidator: RoleFeatureValidator,
      CommitHandler,
    });
  }, [selectedScreen, screenOptions, setSelectedGrid, gridOptions]);

  return <GridTable tableRes={tableRes} />;
};

function SetIsCellEditable(props) {
  const { field, row, access } = props;
  let isEditable = true;
  if (
    ((field === 'role_id' || field === 'screen_grid_feature_id') && row.status !== 'N') ||
    field === 'access_level'
  ) {
    isEditable = false;
    return isEditable;
  }
  const rolePermission = access?.[field]?.accessLevel === 'U';
  return row.status !== 'D' && access?.edit_row && isEditable && rolePermission;
}

function RoleFeatureValidator(rows, row) {
  const result = {
    isValid: true,
    errors: {},
  };
  if (row['screen_grid_feature_id'] && row['role_id']) {
    const filteredRow = rows.filter((item) => {
      return item.status !== 'N' && item.status !== 'E';
    });
    const newCheck = filteredRow.findIndex(
      (item) =>
        item['screen_grid_feature_id'] === row['screen_grid_feature_id'] &&
        item['role_id'] === row['role_id'] &&
        item['access_level'] === row['access_level'],
    );
    if (newCheck >= 0) {
      result.isValid = false;
      result.errors['screen_grid_feature_id'] = {
        field: 'screen_grid_feature_id',
        msg: t('same_role_feature'),
      };
    }
  }
  return result;
}
